import { useLang } from '@/i18n';
import { getSolarRecommand } from '@/service/solar-calculator';
import gtm from '@/utils/gtm';
import { FormatMoneyLocal } from '@elem/ui-common/utils/FormatMoneyLocal';
import EfEmarsysEmail from '@elem/ui/ef-emarsys-email';
import EFAmazon from 'elem/ui-assets/icons/unregular/EFAmazon';
import EfImg from 'elem/ui/ef-img';
import EfLink from 'elem/ui/ef-link';
import EfSpec from 'elem/ui/ef-spec';
import EfTitle from 'elem/ui/ef-title';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useProductStore } from './../../../ProductProvider';
import Dialog from './Dialog';
import { imgLocaleA, imgLocaleB, imgLocaleC } from './Imgs';
import styles from './index.module.scss';
import { cloneDeep } from 'lodash';
import getKRItems, { getEUItems } from './getKRItems';

export default function TheComp() {
    const { t } = useLang('theProduct.OtherA');
    const { locale = 'us' } = useRouter();
    const IS_EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'kr', 'ph', 'nl'].includes(locale);
    const IS_NA_SITES = ['us', 'ca', 'br', 'mx'].includes(locale);
    const IS_R3P = ['eu', 'uk', 'de', 'fr', 'es', 'it', 'nl'].includes(locale);
    const { pageStatus } = useProductStore();
    const [active, setActive] = useState(0);
    const [showDialog, setShowDialog] = useState(false);
    const [isClient, setIsClient] = useState(false);

    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const dateString = `${year}-${month}-${day}`;

    // 产品列表
    const productList = [
        {
            value: 6,
            label: t('win_product1'),
            checked: true,
            fields: [
                {
                    id: '11150',
                    type: 'multiple',
                    value: 6,
                    overwrite: false,
                },
                {
                    id: '9435',
                    type: 'multiple',
                    value: 15,
                    overwrite: false,
                },
            ],
        },
        {
            value: 7,
            label: t('win_product2'),
            checked: true,
            fields: [
                {
                    id: '11150',
                    type: 'multiple',
                    value: 7,
                    overwrite: false,
                },
                {
                    id: '9435',
                    type: 'multiple',
                    value: 15,
                    overwrite: false,
                },
            ],
        },
    ];

    const fieldsMap = (locale: string) => {
        const maps = {
            us: {
                contactListId: ['1831281292', '1157235157'],
                fields: [
                    {
                        id: '11150',
                        type: 'multiple',
                        value: [2],
                        overwrite: false,
                    },
                    {
                        id: '4423',
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        id: '11149',
                        type: 'text',
                        value: dateString,
                        overwrite: true,
                    },
                ],
            },
            ca: {
                contactListId: ['1831281292', '1157235157'],
                fields: [
                    {
                        id: '11150',
                        type: 'multiple',
                        value: [2],
                        overwrite: false,
                    },
                    {
                        id: '4424',
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        id: '11149',
                        type: 'text',
                        value: dateString,
                        overwrite: true,
                    },
                ],
            },
            eu: {
                contactListId: ['324184408'],
                fields: [
                    {
                        id: '4427',
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        id: '31',
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        id: '7596',
                        type: 'multiple',
                        value: [29],
                        overwrite: false,
                    },
                    {
                        id: '9690',
                        type: 'multiple',
                        value: [12],
                        overwrite: false,
                    },
                ],
            },
            uk: {
                contactListId: ['16182394'],
                fields: [
                    {
                        id: '4430',
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        id: '31',
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        id: '7596',
                        type: 'multiple',
                        value: [29],
                        overwrite: false,
                    },
                    {
                        id: '9690',
                        type: 'multiple',
                        value: [12],
                        overwrite: false,
                    },
                ],
            },
            de: {
                contactListId: ['236549250'],
                fields: [
                    {
                        id: '4425',
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        id: '31',
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        id: '7596',
                        type: 'multiple',
                        value: [29],
                        overwrite: false,
                    },
                    {
                        id: '9690',
                        type: 'multiple',
                        value: [12],
                        overwrite: false,
                    },
                ],
            },
            fr: {
                contactListId: ['1053269597'],
                fields: [
                    {
                        id: '4428',
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        id: '31',
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        id: '7596',
                        type: 'multiple',
                        value: [29],
                        overwrite: false,
                    },
                    {
                        id: '9690',
                        type: 'multiple',
                        value: [12],
                        overwrite: false,
                    },
                ],
            },
            it: {
                contactListId: ['1998934371'],
                fields: [
                    {
                        id: '4429',
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        id: '31',
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        id: '7596',
                        type: 'multiple',
                        value: [29],
                        overwrite: false,
                    },
                    {
                        id: '9690',
                        type: 'multiple',
                        value: [12],
                        overwrite: false,
                    },
                ],
            },
            es: {
                contactListId: ['1772671024'],
                fields: [
                    {
                        id: '4426',
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        id: '31',
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        id: '7596',
                        type: 'multiple',
                        value: [29],
                        overwrite: false,
                    },
                    {
                        id: '9690',
                        type: 'multiple',
                        value: [12],
                        overwrite: false,
                    },
                ],
            },
            nl: {
                contactListId: ['324184408'],
                fields: [
                    {
                        id: '4427',
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        id: '31',
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        id: '7596',
                        type: 'multiple',
                        value: [29],
                        overwrite: false,
                    },
                    {
                        id: '9690',
                        type: 'multiple',
                        value: [12],
                        overwrite: false,
                    },
                ],
            },
        };
        return maps[locale] || '';
    };

    const configs = {
        needTerms: true,
        isMulti: true,
        termsHtml: (() => {
            const maps = {
                us: "I consent to the <a href='https://us.ecoflow.com/policies/terms-of-service' target='_blank'>Terms of Use</a> and <a href='https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html' target='_blank'>Privacy Policy</a>.",
                ca: "I consent to the <a href='https://ca.ecoflow.com/policies/terms-of-service' target='_blank'>Terms of Use</a> and <a href='https://account.ecoflow.com/agreement/en-ca/PrivacyPolicy.html' target='_blank'>Privacy Policy</a>.",
                eu: "I consent to the <a href='https://eu.ecoflow.com/policies/terms-of-service' target='_blank'>Terms of Use</a> and <a href='https://eu.ecoflow.com/policies/privacy-policy' target='_blank'>Privacy Policy</a>.",
                uk: "I consent to the <a href='https://uk.ecoflow.com/policies/terms-of-service' target='_blank'>Terms of Use</a> and <a href='https://uk.ecoflow.com/policies/privacy-policy' target='_blank'>Privacy Policy</a>.",
                de: "Ich stimme den <a href='https://de.ecoflow.com/policies/terms-of-service' target='_blank'>Nutzungsbedingungen</a> und der <a href='https://de.ecoflow.com/policies/privacy-policy' target='_blank'>Datenschutzrichtlinie</a> zu.",
                fr: "J'accepte les <a href='https://fr.ecoflow.com/policies/terms-of-service' target='_blank'>Conditions d'utilisation</a> et la <a href='https://fr.ecoflow.com/policies/privacy-policy' target='_blank'>Politique de confidentialité</a>.",
                it: "Acconsento ai <a href='https://it.ecoflow.com/policies/terms-of-service' target='_blank'>Termini di utilizzo</a> e <a href='https://it.ecoflow.com/policies/privacy-policy' target='_blank'>all’Informativa sulla privacy</a>.",
                es: "Acepto los <a href='https://es.ecoflow.com/policies/terms-of-service' target='_blank'>Términos de uso</a> y la <a href='https://es.ecoflow.com/policies/privacy-policy' target='_blank'>Política de privacidad</a>.",
            };
            return maps[locale] || '';
        })(),
        ...fieldsMap(locale),
        tipsObj: {
            successTips: t('successTips'),
        },
    };

    const localLinks: any = {
        us: {
            productId: '7290965622857',
            variantId: '41636504305737',
            // Buy Now
            link_more: 'https://us.ecoflow.com/products/river-3-portable-power-station',
            // Amazon
            link_view: 'https://www.amazon.com/dp/B0DB1S36YP?maas=maas_adg_859899EB00F83EC5F048FAD373EDAAE2_afap_abs&ref_=aa_maas&tag=maas',
        },
        ca: {
            productId: '8335910928538',
            variantId: '45166394409114',
            link_more: 'https://ca.ecoflow.com/products/river-3-portable-power-station',
            link_view: 'https://www.amazon.ca/dp/B0DB4Y5VVT?maas=maas_adg_BD62BF62E23DAD18843AEEF45FE02ABE_afap_abs&ref_=aa_maas&tag=maas',
        },
        eu: {
            productId: '9712614179159',
            variantId: '49500668723543',
            link_more: 'https://eu.ecoflow.com/products/river-3-portable-power-station?variant=49500668723543',
        },
        uk: {
            productId: '9606214418771',
            variantId: '49797546836307',
            link_more: 'https://uk.ecoflow.com/products/river-3-portable-power-station?variant=49797546836307',
        },
        de: {
            productId: '14827510268239',
            variantId: '53660091449679',
            link_more: 'https://de.ecoflow.com/products/river-3-portable-power-station?variant=53660091449679',
        },
        fr: {
            productId: '9582183481691',
            variantId: '49471449465179',
            link_more: 'https://fr.ecoflow.com/products/river-3-portable-power-station?variant=49471449465179',
        },
        it: {
            productId: '14734774665565',
            variantId: '54724579918173',
            link_more: 'https://it.ecoflow.com/products/river-3-portable-power-station?variant=54724579918173',
        },
        es: {
            productId: '9582187151707',
            variantId: '49471467454811',
            link_more: 'https://es.ecoflow.com/products/river-3-portable-power-station?variant=49471467454811',
        },
        nl: {
            productId: '9712614179159',
            variantId: '49500668723543',
            link_more: 'https://nl.ecoflow.com/products/river-3-portable-power-station?variant=49500668723543',
        },
        ph: {
            productId: '10083967598902',
            variantId: '51563840733494',
            link_more: 'https://ph.ecoflow.com/products/river-3-portable-power-station?variant=51563840733494',
        },
    };
    const localLinkObj: any = localLinks[locale] || {};
    const imgA = imgLocaleA[locale] || imgLocaleA['eu'];
    const imgB = imgLocaleB[locale] || imgLocaleB['eu'];
    const imgC = imgLocaleC[locale] || imgLocaleC['eu'];
    const NA_ITEMS = [
        {
            isAmazon: true,
            pc: imgA.pc,
            label: pageStatus === 'statusA' ? t('price_label1_a') : '',
            title: t('item1_title'),
            desc: t('item1_desc'),
            link_more: pageStatus !== 'statusA' ? localLinkObj?.link_more : null,
            link_view: pageStatus !== 'statusA' ? localLinkObj?.link_view : null,
            discountPrice: 0,
            originalPrice: 0,
            icons: [
                {
                    icon: 'EFUPS',
                    title: t('item1_text1'),
                },
                {
                    icon: 'EFRuntime',
                    title: t('item1_text2'),
                },
                {
                    icon: 'EFCompact',
                    title: t('item1_text3'),
                },
            ],
        },
        {
            isDialog: true,
            pc: imgB.pc,
            label: t('price_label2_a'),
            title: t('item2_title'),
            desc: t('item2_desc'),
            icons: [
                {
                    icon: 'EFUPS',
                    title: t('item2_text1'),
                },
                {
                    icon: 'EFRuntime',
                    title: t('item2_text2'),
                },
                {
                    icon: 'EFExpand',
                    title: t('item2_text3'),
                },
            ],
        },
        {
            isDialog: true,
            pc: imgC.pc,
            label: t('price_label3_a'),
            title: t('item3_title'),
            desc: t('item3_desc'),
            icons: [
                {
                    icon: 'EFUPS',
                    title: t('item3_text1'),
                },
                {
                    icon: 'EFRuntime',
                    title: t('item3_text2'),
                },
                {
                    icon: 'EFExpand',
                    title: t('item3_text3'),
                },
            ],
        },
    ];

    const EU_ITEMS = [
        {
            isAmazon: true,
            pc: imgA.pc,
            label: pageStatus === 'statusA' ? t('price_label1_a') : '',
            title: t('item1_title'),
            desc: t('item1_desc'),
            link_more: pageStatus !== 'statusA' ? localLinkObj?.link_more : null,
            link_view: pageStatus !== 'statusA' ? localLinkObj?.link_view : null,
            discountPrice: 249,
            originalPrice: 249,
            icons: [
                {
                    icon: 'EFCompact',
                    title: t('item1_text1'),
                },
                {
                    icon: 'EFRuntime',
                    title: t('item1_text2'),
                },
                {
                    icon: 'EFBattery',
                    title: t('item1_text3'),
                },
                {
                    icon: 'EFUPS',
                    title: t('item1_text4'),
                },
            ],
        },
        {
            isDialog: true,
            pc: imgB.pc,
            label: t('price_label2_a'),
            title: t('item2_title'),
            desc: t('item2_desc'),
            icons: [
                {
                    icon: 'EFRuntime',
                    title: t('item2_text1'),
                },
                {
                    icon: 'EFExpand',
                    title: t('item2_text2'),
                },
                {
                    icon: 'EFBattery',
                    title: t('item2_text3'),
                },
                {
                    icon: 'EFUPS',
                    title: t('item2_text4'),
                },
            ],
        },
        {
            isDialog: true,
            pc: imgC.pc,
            label: t('price_label3_a'),
            title: t('item3_title'),
            desc: t('item3_desc'),
            icons: [
                {
                    icon: 'EFRuntime',
                    title: t('item3_text1'),
                },
                {
                    icon: 'EFExpand',
                    title: t('item3_text2'),
                },
                {
                    icon: 'EFBattery',
                    title: t('item3_text3'),
                },
                {
                    icon: 'EFUPS',
                    title: t('item3_text4'),
                },
            ],
        },
    ];

    const KR_ITEMS = getKRItems(imgA, imgB, imgC, t).items;
    const R3P_ITEMS = getEUItems(imgA, imgB, imgC, t, locale).items;
    const item = IS_R3P ? R3P_ITEMS : IS_NA_SITES ? NA_ITEMS : IS_EU_SITES ? (locale === 'kr' ? KR_ITEMS : EU_ITEMS) : [];
    const [items, setItems] = useState(item);

    const handleChangeTab = (k: number) => {
        setActive(k);
    };

    const handleOpenDialog = (info: any) => {
        setShowDialog(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_join',
            button_name: t('btn3'),
        });
    };

    const Coupon = ['de', 'fr', 'it', 'es'].includes(locale) ? (
        <svg className="coupon" width="161" height="35" viewBox="0 0 161 35" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.5 2.84425C0.5 1.27342 1.77342 0 3.34425 0H157.656C159.227 0 160.5 1.27342 160.5 2.84425V11.7951C158.147 12.5022 156.43 14.7107 156.43 17.3255C156.43 19.9404 158.147 22.1489 160.5 22.8559V32.1557C160.5 33.7266 159.227 35 157.656 35H3.34426C1.77342 35 0.5 33.7266 0.5 32.1557V22.9848C3.1148 22.4643 5.08738 20.1285 5.08738 17.3256C5.08738 14.5227 3.1148 12.1868 0.5 11.6664V2.84425Z"
                fill="url(#paint0_linear_3568_20530)"
            />
            <defs>
                <linearGradient id="paint0_linear_3568_20530" x1="36.5382" y1="0.775107" x2="143.131" y2="-28.6118" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F88B0C" />
                    <stop offset="1" stopColor="#F8610C" />
                </linearGradient>
            </defs>
        </svg>
    ) : (
        <svg className="coupon" xmlns="http://www.w3.org/2000/svg" width="143" height="40" viewBox="0 0 143 40" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.485596 2.81804C0.485596 1.26168 1.74727 0 3.30363 0H140.018C141.574 0 142.836 1.26168 142.836 2.81804V14.2871C139.722 14.2872 137.198 16.8455 137.198 20.0014C137.198 23.1573 139.722 25.7156 142.836 25.7157V37.182C142.836 38.7383 141.574 40 140.018 40H3.30363C1.74727 40 0.485596 38.7383 0.485596 37.182V25.7157C3.59781 25.714 6.12025 23.1563 6.12025 20.0014C6.12025 16.8465 3.59781 14.2887 0.485596 14.2871V2.81804Z"
                fill="url(#paint0_linear_2894_9179)"
            />
            <defs>
                <linearGradient id="paint0_linear_2894_9179" x1="32.5484" y1="0.885837" x2="130.097" y2="-20.0503" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F88B0C" />
                    <stop offset="1" stopColor="#F8610C" />
                </linearGradient>
            </defs>
        </svg>
    );

    const conpon2 = ['de', 'fr', 'it', 'es'].includes(locale) ? (
        <svg className="coupon2" width="153" height="30" viewBox="0 0 153 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="path-1-inside-1_3568_20534" fill="white">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.5 2.52765C0.5 1.13167 1.63167 0 3.02766 0H149.972C151.368 0 152.5 1.13167 152.5 2.52766V7.92961C149.944 9.32614 148.205 12.0777 148.205 15.2438C148.205 18.4099 149.944 21.1615 152.5 22.558V27.4723C152.5 28.8683 151.368 30 149.972 30H3.02765C1.63166 30 0.5 28.8683 0.5 27.4723V22.9996C3.56691 21.8143 5.74732 18.7888 5.74732 15.2436C5.74732 11.6984 3.56691 8.67287 0.5 7.4876V2.52765Z"
                />
            </mask>
            <path
                d="M152.5 7.92961L152.906 8.67215L153.346 8.43153V7.92961H152.5ZM152.5 22.558H153.346V22.0561L152.906 21.8155L152.5 22.558ZM0.5 22.9996L0.194984 22.2103L-0.346122 22.4195V22.9996H0.5ZM0.5 7.4876H-0.346122V8.06771L0.194984 8.27683L0.5 7.4876ZM3.02766 -0.846122C1.16437 -0.846122 -0.346122 0.664369 -0.346122 2.52765H1.34612C1.34612 1.59897 2.09897 0.846122 3.02766 0.846122V-0.846122ZM149.972 -0.846122H3.02766V0.846122H149.972V-0.846122ZM153.346 2.52766C153.346 0.664372 151.836 -0.846122 149.972 -0.846122V0.846122C150.901 0.846122 151.654 1.59897 151.654 2.52766H153.346ZM153.346 7.92961V2.52766H151.654V7.92961H153.346ZM149.051 15.2438C149.051 12.3932 150.615 9.92327 152.906 8.67215L152.094 7.18706C149.272 8.72901 147.358 11.7622 147.358 15.2438H149.051ZM152.906 21.8155C150.615 20.5644 149.051 18.0944 149.051 15.2438H147.358C147.358 18.7254 149.272 21.7586 152.094 23.3006L152.906 21.8155ZM153.346 27.4723V22.558H151.654V27.4723H153.346ZM149.972 30.8461C151.836 30.8461 153.346 29.3356 153.346 27.4723H151.654C151.654 28.401 150.901 29.1539 149.972 29.1539V30.8461ZM3.02765 30.8461H149.972V29.1539H3.02765V30.8461ZM-0.346122 27.4723C-0.346122 29.3356 1.16436 30.8461 3.02765 30.8461V29.1539C2.09897 29.1539 1.34612 28.401 1.34612 27.4723H-0.346122ZM-0.346122 22.9996V27.4723H1.34612V22.9996H-0.346122ZM4.9012 15.2436C4.9012 18.4361 2.93868 21.15 0.194984 22.2103L0.805016 23.7888C4.19514 22.4786 6.59344 19.1415 6.59344 15.2436H4.9012ZM0.194984 8.27683C2.93868 9.33719 4.9012 12.0511 4.9012 15.2436H6.59344C6.59344 11.3457 4.19514 8.00855 0.805016 6.69837L0.194984 8.27683ZM-0.346122 2.52765V7.4876H1.34612V2.52765H-0.346122Z"
                fill="white"
                mask="url(#path-1-inside-1_3568_20534)"
            />
        </svg>
    ) : (
        <svg className="coupon2" xmlns="http://www.w3.org/2000/svg" width="138" height="36" viewBox="0 0 138 36" fill="none">
            <mask id="path-1-inside-1_2894_9183" fill="white">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.302002 3.36178C0.302002 1.97866 1.42324 0.857422 2.80636 0.857422H134.51C135.893 0.857422 137.015 1.97866 137.015 3.36178V9.91515C133.73 11.0916 131.376 14.2668 131.376 17.9992C131.376 21.7315 133.73 24.9067 137.015 26.0832V32.6388C137.015 34.0219 135.893 35.1431 134.51 35.1431H2.80636C1.42324 35.1431 0.302002 34.0219 0.302002 32.6388V26.0828C3.58641 24.9061 5.93952 21.7312 5.93952 17.9992C5.93952 14.2672 3.58641 11.0922 0.302002 9.91551V3.36178Z"
                />
            </mask>
            <path
                d="M137.015 9.91515L137.297 10.7044L137.853 10.5054V9.91515H137.015ZM137.015 26.0832H137.853V25.4929L137.297 25.2939L137.015 26.0832ZM0.302002 26.0828L0.0192536 25.2936L-0.536322 25.4927V26.0828H0.302002ZM0.302002 9.91551H-0.536322V10.5057L0.0192533 10.7047L0.302002 9.91551ZM2.80636 0.0190983C0.96025 0.0190983 -0.536322 1.51566 -0.536322 3.36178H1.14033C1.14033 2.44165 1.88623 1.69575 2.80636 1.69575V0.0190983ZM134.51 0.0190983H2.80636V1.69575H134.51V0.0190983ZM137.853 3.36178C137.853 1.51567 136.356 0.0190983 134.51 0.0190983V1.69575C135.43 1.69575 136.176 2.44166 136.176 3.36178H137.853ZM137.853 9.91515V3.36178H136.176V9.91515H137.853ZM132.215 17.9992C132.215 14.626 134.341 11.7632 137.297 10.7044L136.732 9.12592C133.119 10.4199 130.538 13.9075 130.538 17.9992H132.215ZM137.297 25.2939C134.341 24.2351 132.215 21.3723 132.215 17.9992H130.538C130.538 22.0908 133.119 25.5784 136.732 26.8724L137.297 25.2939ZM137.853 32.6388V26.0832H136.176V32.6388H137.853ZM134.51 35.9815C136.356 35.9815 137.853 34.4849 137.853 32.6388H136.176C136.176 33.5589 135.43 34.3048 134.51 34.3048V35.9815ZM2.80636 35.9815H134.51V34.3048H2.80636V35.9815ZM-0.536322 32.6388C-0.536322 34.4849 0.960251 35.9815 2.80636 35.9815V34.3048C1.88624 34.3048 1.14033 33.5589 1.14033 32.6388H-0.536322ZM-0.536322 26.0828V32.6388H1.14033V26.0828H-0.536322ZM5.1012 17.9992C5.1012 21.372 2.97538 24.2345 0.0192536 25.2936L0.58475 26.872C4.19743 25.5777 6.77785 22.0904 6.77785 17.9992H5.1012ZM0.0192533 10.7047C2.97538 11.7638 5.1012 14.6264 5.1012 17.9992H6.77785C6.77785 13.9079 4.19743 10.4206 0.584751 9.1263L0.0192533 10.7047ZM-0.536322 3.36178V9.91551H1.14033V3.36178H-0.536322Z"
                fill="white"
                mask="url(#path-1-inside-1_2894_9183)"
            />
        </svg>
    );

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    useEffect(() => {
        if (pageStatus !== 'statusA') {
            (async () => {
                const { productId, variantId } = localLinkObj;

                if (locale === 'kr') {
                    const idItems = [
                        {
                            productId: '8499061194921',
                            variantId: '45732068786345',
                        },

                        {
                            productId: '8499164414121',
                            variantId: '45733372068009',
                        },
                        {
                            productId: '8499184271529',
                            variantId: '45733614256297',
                        },
                    ];

                    const newItems = cloneDeep(items);
                    await Promise.all(
                        idItems.map(async (item, index) => {
                            const res = await getSolarRecommand({ productId: item.productId, variantId: item.variantId }, locale);
                            if (res?.code === '0') {
                                newItems[index].discountPrice = res?.data?.price;
                                newItems[index].originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                                newItems[index].inventory = res?.data?.inventoryQuantity ?? undefined;
                            }
                        }),
                    );
                    setItems(newItems);
                } else if (IS_R3P) {
                    const idItemsR3P: { [key: string]: any } = {
                        eu: [
                            {
                                productId: '9712614179159',
                                variantId: '49500668723543',
                            },

                            {
                                productId: '9912452940119',
                                variantId: '50144528204119',
                            },
                            {
                                productId: '9912452940119',
                                variantId: '50144528236887',
                            },
                        ],
                        uk: [
                            {
                                productId: '9606214418771',
                                variantId: '49797546836307',
                            },

                            {
                                productId: '9803871682899',
                                variantId: '50552824856915',
                            },
                            {
                                productId: '9803871682899',
                                variantId: '50552824889683',
                            },
                        ],
                        de: [
                            {
                                productId: '14827510268239',
                                variantId: '53660091449679',
                            },

                            {
                                productId: '15064412520829',
                                variantId: '55476457177469',
                            },
                            {
                                productId: '15064412520829',
                                variantId: '55476457210237',
                            },
                        ],
                        fr: [
                            {
                                productId: '9582183481691',
                                variantId: '49471449465179',
                            },

                            {
                                productId: '9781516861787',
                                variantId: '50209756479835',
                            },
                            {
                                productId: '9781516861787',
                                variantId: '50209756512603',
                            },
                        ],
                        es: [
                            {
                                productId: '9582187151707',
                                variantId: '49471467454811',
                            },

                            {
                                productId: '9781516763483',
                                variantId: '50209756053851',
                            },
                            {
                                productId: '9781516763483',
                                variantId: '50209756086619',
                            },
                        ],
                        it: [
                            {
                                productId: '14734774665565',
                                variantId: '54724579918173',
                            },

                            {
                                productId: '14893036011896',
                                variantId: '54969500795256',
                            },
                            {
                                productId: '14893036011896',
                                variantId: '54969500828024',
                            },
                        ],
                        nl: [
                            {
                                productId: '9935710912788',
                                variantId: '51194414924052',
                            },

                            {
                                productId: '9935711568148',
                                variantId: '51194421510420',
                            },
                            {
                                productId: '9935711568148',
                                variantId: '51194421608724',
                            },
                        ],
                    };
                    const newItems = cloneDeep(items);
                    await Promise.all(
                        idItemsR3P[locale].map(async (item, index) => {
                            const res = await getSolarRecommand({ productId: item.productId, variantId: item.variantId }, locale);
                            if (res?.code === '0') {
                                newItems[index].discountPrice = res?.data?.price;
                                newItems[index].originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                                newItems[index].inventory = res?.data?.inventoryQuantity ?? undefined;
                            }
                        }),
                    );
                    setItems(newItems);
                } else {
                    const res = await getSolarRecommand({ productId, variantId }, locale);

                    const temp = JSON.parse(JSON.stringify(items[0]));
                    if (res?.code === '0') {
                        temp.discountPrice = res?.data?.price;
                        temp.originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                        temp.inventory = res?.data?.inventoryQuantity ?? undefined;
                        // temp.link_buy = `https://${locale}.ecoflow.com/cart/${variantId}:1?channel=buy_button`;
                    }
                    setItems([temp, ...items.slice(1)]);
                }
            })();
        }
    }, [pageStatus]);

    return (
        <div className={styles.TheComp} id="id-OtherA">
            <EfSpec className={'spec-x'} />
            <EfTitle hasAnimation={false}>{t('title')}</EfTitle>
            {!IS_NA_SITES && !IS_EU_SITES && (
                <div className="email-wrapper">
                    {pageStatus === 'statusA' && <EfEmarsysEmail {...configs} />}
                    <div className={`gift gift-${IS_EU_SITES ? 'eu' : IS_NA_SITES ? 'na' : locale}`}>
                        <div className="box1">
                            <span className="get">{t('cc_1')}</span>
                            <div className="coupon-box">
                                {IS_NA_SITES && (
                                    <>
                                        {Coupon}
                                        {conpon2}
                                    </>
                                )}
                                <div className="coupon-off">
                                    <span className="text">{t('cc_2')}</span>
                                    {IS_NA_SITES && <span className="text off">{t('cc_3')}</span>}
                                </div>
                            </div>
                        </div>
                        {
                            <>
                                {IS_NA_SITES && (
                                    <span className="plus">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M6.83593 0H4.83593V3.9998L0.835938 3.9998V5.9998H4.83593V10H6.83593V5.9998H10.8359V3.9998L6.83593 3.9998V0Z"
                                                fill="black"
                                            />
                                        </svg>
                                    </span>
                                )}
                                <div className="box2">
                                    <span className="bag">{t('cc_4')}</span>
                                    <div className="img">
                                        <EfImg
                                            pc={
                                                IS_EU_SITES
                                                    ? 'https://websiteoss.ecoflow.com/upload/image/1725271211842/camping_light.png'
                                                    : 'https://websiteoss.ecoflow.com/upload/image/1724149682378/aa1.png'
                                            }
                                        />
                                        <div className="coupon-wrapper">
                                            {Coupon}
                                            {conpon2}
                                            <span className="worth">{t('cc_5')}</span>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </div>
            )}
            <ul className="items">
                {items?.map((item: any, k: number) => (
                    <li className={`item${active === k ? ' active' : ''}`} key={k}>
                        <div className="item-top">
                            <div className="item-img">
                                <EfImg pc={item.pc} />
                            </div>
                            <p className="item-title">{item.title}</p>
                            <p className="item-desc">{item.desc}</p>
                            <ul className="item-lists">
                                {item?.icons?.map((list: any, m: number) => (
                                    <li className="item-list" key={`${k}_${m}`}>
                                        <div className="list-icon">
                                            {list.icon === 'EFUPS' ? (
                                                <EFUPS id={`${k}_${m}`} />
                                            ) : list.icon === 'EFRuntime' ? (
                                                <EFRuntime id={`${k}_${m}`} />
                                            ) : list.icon === 'EFBattery' ? (
                                                <EFBattery id={`${k}_${m}`} />
                                            ) : list.icon === 'EFExpand' ? (
                                                <EFExpand id={`${k}_${m}`} />
                                            ) : (
                                                <EFCompact id={`${k}_${m}`} />
                                            )}
                                        </div>
                                        <p className="list-text">{list.title}</p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="item-footer">
                            {item?.label && <p className="item-label">{item?.label}</p>}
                            {pageStatus !== 'statusA' && (
                                <>
                                    {item?.discountPrice && (
                                        <div className="item-price-box">
                                            <span className="item-price price-discount">{FormatMoneyLocal(item?.discountPrice, locale)}</span>
                                            {item?.discountPrice !== item?.originalPrice && (
                                                <span className="item-price price-original">{FormatMoneyLocal(item?.originalPrice, locale)}</span>
                                            )}
                                        </div>
                                    )}
                                    <div className={`item-btns${IS_EU_SITES || (pageStatus === 'statusC' && locale === 'ca') ? ' single' : ''}`}>
                                        {item?.isAmazon && (
                                            <>
                                                {IS_NA_SITES && (
                                                    <EfLink
                                                        className="btn amazon"
                                                        href={item.link_view}
                                                        dataLayer={{
                                                            event: 'uaEvent',
                                                            event_name: 'buy_on_amazon',
                                                            product_name: item.title,
                                                            button_name: t('btn1'),
                                                            list_name: t('title'),
                                                        }}
                                                    >
                                                        <span className="buy">{t('btn1')}</span>
                                                        <EFAmazon />
                                                    </EfLink>
                                                )}
                                                {(locale !== 'ca' || pageStatus !== 'statusC') && (
                                                    <EfLink
                                                        className="btn shopify"
                                                        href={item.link_more}
                                                        dataLayer={{
                                                            event: 'uaEvent',
                                                            event_name: 'buy',
                                                            product_name: item.title,
                                                            position: `In-Products Module`,
                                                        }}
                                                    >
                                                        {t('btn2')}
                                                    </EfLink>
                                                )}
                                            </>
                                        )}
                                        {item?.isDialog && (
                                            <button className="btn notify" onClick={() => handleOpenDialog(item)}>
                                                {t('btn3')}
                                            </button>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                    </li>
                ))}
            </ul>
            <div className="tabs-wrapper">
                <ul className="tabs">
                    {items?.map((item: any, k: number) => (
                        <li className={`tab${active === k ? ' active' : ''}`} key={k} onClick={() => handleChangeTab(k)}>
                            {item.title}
                        </li>
                    ))}
                </ul>
            </div>
            <EfSpec className={'spec-x'} />
            {showDialog &&
                isClient &&
                createPortal(
                    <Dialog configs={{ ...configs, productList: IS_NA_SITES ? productList : [] }} callback={() => setShowDialog(false)} />,
                    document.body,
                )}
        </div>
    );
}

export const EFUPS = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.2502 4.1875C8.73039 4.1875 6.68769 6.2302 6.68769 8.75V22.1875H5.5891C5.48537 22.1875 5.42677 22.3066 5.49005 22.3888L7.40114 24.8713C7.45118 24.9363 7.5492 24.9363 7.59924 24.8713L9.51033 22.3888C9.57361 22.3066 9.51501 22.1875 9.41128 22.1875H8.31269V8.75C8.31269 7.12766 9.62785 5.8125 11.2502 5.8125C12.8725 5.8125 14.1877 7.12766 14.1877 8.75V10.625V16.875V20C14.1877 22.5198 16.2304 24.5625 18.7502 24.5625C21.27 24.5625 23.3127 22.5198 23.3127 20V7.8125H24.4113C24.515 7.8125 24.5736 7.69345 24.5103 7.61125L22.5992 5.12867C22.5492 5.06367 22.4512 5.06367 22.4011 5.12867L20.49 7.61125C20.4268 7.69345 20.4854 7.8125 20.5891 7.8125H21.6877V20C21.6877 21.6223 20.3725 22.9375 18.7502 22.9375C17.1279 22.9375 15.8127 21.6223 15.8127 20V16.875V10.625V8.75C15.8127 6.2302 13.77 4.1875 11.2502 4.1875Z"
            fill={`url(#paint0_linear_992_56959_${props.id})`}
        />
        <defs>
            <linearGradient id={`paint0_linear_992_56959_${props.id}`} x1="5.00098" y1="23.125" x2="10.001" y2="23.125" gradientUnits="userSpaceOnUse">
                <stop stopColor="#1B389D" />
                <stop offset="1" stopColor="#2955D3" />
            </linearGradient>
        </defs>
    </svg>
);

export const EFRuntime = (props: any) => (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M6.95691 22.8654C8.99942 24.9538 11.8485 26.25 15 26.25C21.2126 26.25 26.25 21.2126 26.25 15C26.25 8.78739 21.2126 3.75 15 3.75C11.9692 3.75 9.21812 4.94884 7.19513 6.89813"
            stroke={`url(#paint0_linear_1272_64950_${props.id})`}
            strokeWidth="1.625"
            strokeLinecap="round"
        />
        <path
            d="M6.875 3.75V7.1875L10.625 7.5"
            stroke={`url(#paint1_linear_1272_64950_${props.id})`}
            strokeWidth="1.625"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15 8.75V16.25L20 13.75"
            stroke={`url(#paint2_linear_1272_64950_${props.id})`}
            strokeWidth="1.625"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.25 10L3.125 15H7.5L4.375 20"
            stroke={`url(#paint3_linear_1272_64950_${props.id})`}
            strokeWidth="1.625"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <defs>
            <linearGradient id={`paint0_linear_1272_64950_${props.id}`} x1="6.95691" y1="15" x2="26.25" y2="15" gradientUnits="userSpaceOnUse">
                <stop stopColor="#1B389D" />
                <stop offset="1" stopColor="#2955D3" />
            </linearGradient>
            <linearGradient id={`paint1_linear_1272_64950_${props.id}`} x1="6.875" y1="5.625" x2="10.625" y2="5.625" gradientUnits="userSpaceOnUse">
                <stop stopColor="#1B389D" />
                <stop offset="1" stopColor="#2955D3" />
            </linearGradient>
            <linearGradient id={`paint2_linear_1272_64950_${props.id}`} x1="15" y1="12.5" x2="20" y2="12.5" gradientUnits="userSpaceOnUse">
                <stop stopColor="#1B389D" />
                <stop offset="1" stopColor="#2955D3" />
            </linearGradient>
            <linearGradient id={`paint3_linear_1272_64950_${props.id}`} x1="3.125" y1="15" x2="7.5" y2="15" gradientUnits="userSpaceOnUse">
                <stop stopColor="#1B389D" />
                <stop offset="1" stopColor="#2955D3" />
            </linearGradient>
        </defs>
    </svg>
);

export const EFCompact = (props: any) => (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.38 5.38V24.62H24.62V5.38H5.38ZM4.6875 3.75C4.16973 3.75 3.75 4.16973 3.75 4.6875V25.3125C3.75 25.8303 4.16973 26.25 4.6875 26.25H25.3125C25.8303 26.25 26.25 25.8303 26.25 25.3125V4.6875C26.25 4.16973 25.8303 3.75 25.3125 3.75H4.6875ZM13.12 18.0326L12.8124 22.0312C12.7779 22.48 13.1137 22.8718 13.5625 22.9063C14.0113 22.9409 14.4031 22.605 14.4376 22.1563L14.8812 16.3897C14.9327 15.7194 14.3744 15.161 13.7041 15.2126L7.93749 15.6562C7.48871 15.6907 7.15288 16.0825 7.1874 16.5313C7.22192 16.98 7.61372 17.3159 8.06251 17.2813L11.858 16.9894L7.42371 21.4237C7.10543 21.742 7.10543 22.258 7.42371 22.5763C7.74199 22.8946 8.25801 22.8946 8.57629 22.5763L13.12 18.0326ZM16.9894 11.858L17.2813 8.06251C17.3159 7.61372 16.98 7.22192 16.5313 7.1874C16.0825 7.15288 15.6907 7.48871 15.6562 7.93749L15.2126 13.7041C15.161 14.3744 15.7194 14.9327 16.3897 14.8812L22.1563 14.4376C22.605 14.4031 22.9409 14.0113 22.9063 13.5625C22.8718 13.1137 22.48 12.7779 22.0312 12.8124L18.0326 13.12L22.5763 8.57629C22.8946 8.25801 22.8946 7.74199 22.5763 7.42371C22.258 7.10543 21.742 7.10543 21.4237 7.42371L16.9894 11.858Z"
            fill={`url(#paint0_linear_1203_7311_${props.id})`}
        />
        <defs>
            <linearGradient id={`paint0_linear_1203_7311_${props.id}`} x1="26.25" y1="15" x2="3.75" y2="15" gradientUnits="userSpaceOnUse">
                <stop stopColor="#1B389D" />
                <stop offset="1" stopColor="#2955D3" />
            </linearGradient>
        </defs>
    </svg>
);

export const EFBattery = (props: any) => (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.6246 1.18506C10.8293 1.18506 10.1846 1.82977 10.1846 2.62506V4.18506H8.12457C7.32928 4.18506 6.68457 4.82977 6.68457 5.62506V25.6251C6.68457 26.4203 7.32928 27.0651 8.12457 27.0651H21.8746C22.6699 27.0651 23.3146 26.4203 23.3146 25.6251V5.62506C23.3146 4.82977 22.6699 4.18506 21.8746 4.18506H19.8146V2.62506C19.8146 1.82977 19.1699 1.18506 18.3746 1.18506H11.6246ZM18.1846 4.18506V2.81506H11.8146V4.18506H18.1846ZM11.6246 5.81506H8.31457V25.4351H21.6846V5.81506H18.3746H11.6246ZM15.3596 13.4006H18.3258C18.5598 13.4006 18.7496 13.6208 18.7496 13.8924C18.7496 13.9822 18.7284 14.0702 18.6884 14.147L14.4471 22.2825C14.336 22.4956 14.0972 22.5638 13.9136 22.4349C13.774 22.3369 13.702 22.1481 13.7335 21.9622L14.6399 16.6086H11.6734C11.4393 16.6086 11.2496 16.3884 11.2496 16.1167C11.2496 16.027 11.2707 15.9391 11.3107 15.8623L15.5527 7.71775C15.6637 7.50466 15.9025 7.43633 16.0861 7.56513C16.2258 7.66309 16.2978 7.85192 16.2664 8.03776L15.3596 13.4006Z"
            fill={`url(#paint0_linear_1336_16601_${props?.id})`}
        />
        <defs>
            <linearGradient id={`paint0_linear_1336_16601_${props?.id}`} x1="6.68457" y1="14.1251" x2="23.3146" y2="14.1251" gradientUnits="userSpaceOnUse">
                <stop stopColor="#1B389D" />
                <stop offset="1" stopColor="#2955D3" />
            </linearGradient>
        </defs>
    </svg>
);

export const EFExpand = (props: any) => (
    <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M5.31827 11.6521C5.212 11.5785 5.212 11.4215 5.31828 11.3479L15.827 4.07342L15.3631 3.40331L15.827 4.07342C15.8915 4.02872 15.9773 4.02966 16.0409 4.07576L16.5193 3.41599L16.0409 4.07576L26.0719 11.3502C26.1737 11.4241 26.1737 11.5759 26.0719 11.6498L16.0409 18.9242C15.9773 18.9703 15.8915 18.9713 15.827 18.9266L5.31827 11.6521Z"
            stroke={`url(#paint0_linear_1272_65007_${props?.id})`}
            strokeWidth="1.63"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.24791 14.6362L4.85429 17.6776C4.27985 18.0753 4.27985 18.9244 4.85429 19.3221L15.363 26.5966C15.712 26.8382 16.1756 26.8331 16.5192 26.5839L26.5502 19.3094C27.1008 18.9101 27.1008 18.0896 26.5502 17.6903L22.3388 14.6362L20.9085 15.6125L24.89 18.4999L15.9237 25.0023L6.53034 18.4999L10.7232 15.5974L9.24791 14.6362Z"
            fill={`url(#paint1_linear_1272_65007_${props?.id})`}
        />
        <defs>
            <linearGradient id={`paint0_linear_1272_65007_${props?.id}`} x1="3.66663" y1="11.5" x2="27.6666" y2="11.5" gradientUnits="userSpaceOnUse">
                <stop stopColor="#1B389D" />
                <stop offset="1" stopColor="#2955D3" />
            </linearGradient>
            <linearGradient id={`paint1_linear_1272_65007_${props?.id}`} x1="4.42346" y1="20.7053" x2="26.9632" y2="20.7053" gradientUnits="userSpaceOnUse">
                <stop stopColor="#1B389D" />
                <stop offset="1" stopColor="#2955D3" />
            </linearGradient>
        </defs>
    </svg>
);
